import PropTypes from 'prop-types';
export const horizontalProductPropTypes = {
  /**
   * Picture attributes: src and alt
   */
  picture: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
    caption: PropTypes.string
  }),
  /**
   * Heading content
   */
  heading: PropTypes.string,
  /**
   * Text content
   */
  text: PropTypes.string,
  /**
   * Button: label and href content
   */
  button: PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.string
  }),
  quote: PropTypes.shape({
    text: PropTypes.string,
    name: PropTypes.string,
    image: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string
    })
  })
};